import { EventEmitter } from "utilFunctions/Emitter/EventEmitter";
export const myBatchEmitter = new EventEmitter();
export const drsEmitter = new EventEmitter();
